import { CheckCircleIcon, FadeIn } from "staysure-component-library";

import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import RichText from "@/components/atoms/rich-text/rich-text";
import ToggleBtnLabelWrapper from "@/components/atoms/toggle-btn-wrapper/toggle-btn-label-wrapper";
import { smoothScrollTopScreen } from "@/utils/scrollUtils";

import { useContactDetailsContext } from "../../../provider/contact-details.provider";
import { formCmsData } from "../../../utils/contact-details-page.util";

function ContactdetilasPreferenceSection() {
  const { cmsData, formValues, setters, flags } = useContactDetailsContext();
  const { subtitle, preferenceDescription } = formCmsData(cmsData);

  const { contactPreferenceLabels, contactPreferences, preferences } =
    formValues;

  const { setPreferences } = setters;
  const { isPreferenceClicked } = flags;

  const { current } = useWizard();

  return (
    <>
      <div className="mt-spacing-l">
        {subtitle && (
          <h2 className="font-body-font md:text-[20px] text-[18px] text-text-title font-sub-header-font md:leading-[28.75px] leading-[20.7px] ">
            {subtitle}
          </h2>
        )}
      </div>
      <RichText
        richText={preferenceDescription}
        className="text-[14px] break-words font-body-font md:mt-spacing-xs mt-spacing-xxs leading-[21px] text-text-body contact-rich-text"
      />
      <div className=" mt-spacing-s md:mb-spacing-l ">
        {isPreferenceClicked && (
          <FadeIn
            isVisible={isPreferenceClicked}
            data-testid="preferences-fade-in-animation"
            onStart={smoothScrollTopScreen}
          >
            <div
              className={`grid ${
                current?.uiElementControls?.marketingPreferencesBtnCompactLayout
                  ? "grid-cols-2"
                  : "md:grid-cols-4 grid-cols-2"
              }  gap-spacing-xs p-spacing-xs`}
            >
              {contactPreferences.map((preference, index) => (
                <div key={`preference ${index as unknown as string}`}>
                  <ToggleBtnLabelWrapper
                    id={`contact-preference-${index}`}
                    btnType="button"
                    label={contactPreferenceLabels[index] as string}
                    isDefaultActive={preferences[preference]}
                    onClick={(e: boolean) => {
                      setPreferences({
                        ...preferences,
                        [preference]: e,
                      });
                    }}
                    isActiveRightIcon
                    activeRightIcon={<CheckCircleIcon semanticColor="dark" />}
                    className="border-[1px] border-interactive-secondary-default text-[16px]
                                  text-text-on-primary w-full h-[56px] rounded-lg font-semibold font-body-font
                                   py-spacing-s md:px-spacing-xs lg:px-spacing-s px-spacing-s flex flex-col justify-center items-start
                                  gap-grid-system-space-050 leading-[24px]"
                  />
                </div>
              ))}
            </div>
          </FadeIn>
        )}
      </div>
    </>
  );
}
export default ContactdetilasPreferenceSection;
